import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import {
  FormGroup,
  Input,
  Label,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import HelpIcon from '../HelpIcon';

const FiltersFileNoCollections = ({
  filters,
  availableFilters,
  handleChangeFilters,
  prefix,
}) => {
  const intl = useIntl();

  if (!_.isBoolean(availableFilters)) return null;

  return (
    <div className="files-filter file-no-collections-filter">
      <div className="filter-header">
        <FormGroup check>
          <Label for={`${prefix}fileNoCollectionsFilter`} className="filter-title" check>
            <Input
              type="checkbox"
              id={`${prefix}fileNoCollectionsFilter`}
              className="input-check check-s form-check-input no-margin"
              value="1"
              checked={Boolean(filters)}
              onChange={(e) => handleChangeFilters(
                { no_collections: e.target.checked ? e.target.checked : null },
              )}
            />
            <span>{intl.formatMessage({ defaultMessage: 'No Collections' })}</span>
            &nbsp;
            <HelpIcon id="files-with-no-collections-tooltip">
              {intl.formatMessage({ defaultMessage: 'View your workspace files that do not belong to any Collections' })}
            </HelpIcon>
          </Label>
        </FormGroup>
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => ({
  filters: props.customFilters ?
    props.customFilters.no_collections : state.Files.filters.no_collections,
  availableFilters: state.Files.availableFilters.no_collections,
});

FiltersFileNoCollections.propTypes = {
  filters: PropTypes.bool,
  handleChangeFilters: PropTypes.func.isRequired,
  availableFilters: PropTypes.bool,
  prefix: PropTypes.string,
};

FiltersFileNoCollections.defaultProps = {
  filters: false,
  availableFilters: false,
  prefix: '',
};

export default connect(mapStateToProps)(FiltersFileNoCollections);
